/**
 * Maps the US/Canada timezone abbreviations stored in the legacy
 * `tbl_time_zone` table (exposed as `location.timeZone.shortName`) to a
 * proper IANA zone identifier moment-timezone can resolve. The stored
 * abbreviation is a static label that doesn't track DST on its own (e.g. may
 * always read "EST" even in summer), but the IANA zone applies real DST
 * rules for any given date, so mapping to it is correct even when the source
 * abbreviation is stale.
 */
const ABBREVIATION_TO_IANA: Record<string, string> = {
  EST: "America/New_York",
  EDT: "America/New_York",
  CST: "America/Chicago",
  CDT: "America/Chicago",
  MST: "America/Denver",
  MDT: "America/Denver",
  PST: "America/Los_Angeles",
  PDT: "America/Los_Angeles",
  AKST: "America/Anchorage",
  AKDT: "America/Anchorage",
  HST: "Pacific/Honolulu",
  HDT: "Pacific/Honolulu",
  AST: "America/Halifax",
  ADT: "America/Halifax",
};

export const resolveIanaTimeZone = (
  abbreviation?: string,
): string | undefined =>
  abbreviation ? ABBREVIATION_TO_IANA[abbreviation.toUpperCase()] : undefined;
